// @flow
const MimeType: PKMimeTypes = {
  HLS: ['application/x-mpegurl', 'application/vnd.apple.mpegurl'],
  DASH: ['application/dash+xml'],
  PROGRESSIVE: ['video/mp4'],
  SMOOTH_STREAMING: ['application/vnd.ms-sstr+xml']
};

export {MimeType};



// WEBPACK FOOTER //
// ./mime-type.js


// WEBPACK FOOTER //
// core/mime-type.js